import { render, staticRenderFns } from "./LaboratoryExams.html?vue&type=template&id=5347946a&external"
import script from "./LaboratoryExams.vue?vue&type=script&lang=js"
export * from "./LaboratoryExams.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryExams.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports